<template>
  <modal-wrap
    ref="downloadWarningModal"
    :name="DOWNLOAD_LABELS_WARNING"
    :header-class="'service-level-header'"
    :body-class="'service-level-modal'"
    :hide-footer="false"
    size="lg"
  >
    <template #modal-title> The labels may be outdated or already used</template>
    <template #default>
      <div v-if="assignmentsWithDeny.length > 0" class="pt-4">
        <OneAssignment v-if="assignmentsWithDeny.length === 1" :assignment="assignmentsWithDeny[0]" />
        <MultipleAssignments v-else :assignments="assignmentsWithDeny" />
      </div>
      <div class="pt-2">
        If you really need to download these labels you can proceed anyway, but you might consider creating new labels.
      </div>
    </template>
    <template #modal-footer>
      <b-button size="md" class="btn-grey mr-3" @click="closeModal"> Cancel</b-button>
      <b-button variant="success" size="md" class="btn-green" @click="downloadLabels"> Download anyway</b-button>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { BButton } from 'bootstrap-vue-next'
import { computed, type ComputedRef, defineComponent } from 'vue'
import { DOWNLOAD_LABELS, DOWNLOAD_LABELS_WARNING } from '@/const/ModalTypes'
import { openModal } from '@/services/Modal'
import { useVueNextModalStore } from '@/store/vueNextModal'
import ModalWrap from '@/views/Modals/ModalWrap.vue'
import OneAssignment from '@/views/Modals/Assignment/DownloadLabelsWarning/OneAssignment.vue'
import MultipleAssignments from '@/views/Modals/Assignment/DownloadLabelsWarning/MultipleAssignments.vue'

export default defineComponent({
  name: 'DownloadLabelsWarning',
  components: { BButton, MultipleAssignments, OneAssignment, ModalWrap },
  setup() {
    const modalStore = useVueNextModalStore()

    const assignments: ComputedRef<Assignment[]> = computed(
      () => modalStore.modalPropsByName(DOWNLOAD_LABELS_WARNING)?.assignments || [],
    )

    const assignmentsWithDeny: ComputedRef<Assignment[]> = computed(() =>
      assignments.value.filter((a) => a.denyLabelsDownload),
    )

    const closeModal = () => {
      modalStore.closeModal(DOWNLOAD_LABELS_WARNING)
    }

    const downloadLabels = () => {
      if (!assignments.value) {
        return
      }

      const ids = assignments.value.map((assignment) => assignment.id)

      closeModal()
      openModal(DOWNLOAD_LABELS, { ids, assignments: assignments.value })
    }

    return {
      DOWNLOAD_LABELS_WARNING,
      assignmentsWithDeny,
      closeModal,
      downloadLabels,
    }
  },
})
</script>
